module.exports = __webpack_public_path__ + "static/img/news3.4a6b87f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/newscenter/news3.jpg
// module id = K8yR
// module chunks = 0